// extracted by mini-css-extract-plugin
export default {"adminProfileImg":"UserForm_adminProfileImg__m7xID"};